import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function PaymentDetailIp(props){
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [cashier, setCashier] = useState({ username: '' });
  const [rows, setRows] = useState([]);
  const [userData, setUserData] = useState([]);
  const [combinedData, setcombinedData] = useState([]);
  const [refundData, setRefundData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleStartDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setStartDate(localDate);
};
 const handleEndDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setEndDate(localDate);
};
  const handleUser = (event) => {
      setCashier({
        ...cashier,
        username: event.target.value
      });
    };
  useEffect(() => {
    try {
        axios.get(`${baseUrl}user-search/`)
        .then(function (response) {
            setUserData(response.data);
        });
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
      fetchData();
  }, [startDate, endDate, cashier]);
  useEffect(() => {
      if (combinedData.length > 0) {
        setRows(combinedData);
      }
  }, [combinedData]);

function fetchData() {
    setIsLoading(true);
    const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
    const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
    const url = `${baseUrl}all-ip-collection-view/?start_date=${startDateString}&end_date=${endDateString}&cashier=${cashier.username}&mode=&status=2`;
    axios.get(url)
      .then(response => {
        // Process the data before setting it
        const processedData = response.data.map(item => ({
          ...item,
          fee: item.advance || item.lab_tot || item.inv_tot || item.min_tot || '',
          paid: item.paid || item.lab_paid || item.inv_paid || item.min_paid || '',
          balance: item.balance || item.lab_balance || item.inv_balance || item.min_balance || '',
          lab_disc: item.lab_disc || item.inv_disc || item.min_disc || '',
          mode: item.mode || item.lab_pmode || item.inv_pmode || item.min_pmode || '',
          invoice: item.invoice || item.lab_invoice || item.inv_invoice || item.min_invoice || '',
        }));
        setcombinedData(processedData);
        setIsLoading(false);
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
      });
  }

  // Fetch refund data
  function fetchRefData() {
    setIsLoading(true);
    const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
    const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
    const url = `${baseUrl}ip-refund-report-view/?start_date=${startDateString}&end_date=${endDateString}`;
    axios.get(url)
      .then(response => {
        setRefundData(response.data);
        setIsLoading(false);
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
      });
  }
  useEffect(() => {
      fetchrefData();
  }, [startDate, endDate]);

  function fetchrefData() {
  setIsLoading(true);
  const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
  const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
    const url = `${baseUrl}ip-refund-report-view/?start_date=${startDateString}&end_date=${endDateString}`;
  axios.get(url)
    .then(response => {
      setRefundData(response.data);
      setIsLoading(false);
    })
    .catch(error => {
      console.log(error);
      setIsLoading(false);
    });
  }

 const columnsInvoiced = [
    { field: "add_date_date", headerName: "Date", width: 110 },
    { field: "ip__ip_id", headerName: "IP ID", width: 100 },
    { field: "appt_id", headerName: "Appointment ID", width: 130 },
    { field: "ip__pat__pat_id", headerName: "Patient ID", width: 120 },
    { field: "ip__pat__patient", headerName: "Patient Name", width: 140 },
    {
      field: "invoice",
      headerName: "Invoice/Receipt No",
      renderCell: (params) => (
        <Link
          to={
            params.row.invoice
              ? `/ip-invoice/${params.row.invoice}`
              : params.row.lab_invoice
              ? `/lab-invoice-ip/${params.row.lab_invoice}`
              : params.row.inv_invoice
              ? `/inv-invoice-ip/${params.row.inv_invoice}`
              : params.row.min_invoice
              ? `/min-invoice-ip/${params.row.min_invoice}`
              : ""
          }
          target="_blank"
        >
          {params.row.invoice || params.row.lab_invoice || params.row.inv_invoice || params.row.min_invoice}
        </Link>
      ),
      width: 160,
    },
    {
      field: 'fee',
      headerName: 'Total Amount',
      width: 130,
    },
    {
      field: 'paid',
      headerName: 'Paid Amount',
      width: 130,
    },
    {
      field: 'balance',
      headerName: 'Balance Amount',
      width: 150,
    },
    {
      field: 'lab_disc',
      headerName: 'Disc Amount',
      width: 130,
    },
    {
      field: 'mode',
      headerName: 'Payment Mode',
      width: 150,
    },
    { field: 'cashier', headerName: "Cashier", width: 120 },
  ];

  // Columns definition for refund report
  const columns1 = [
    { field: 'add_date', headerName: 'Date', width: 110 },
    { field: 'ip__ip_id', headerName: 'IP ID', width: 100 },
    { field: 'ip__pat__pat_id', headerName: 'Pat ID', width: 100 },
    { field: 'ip__pat__patient', headerName: 'Patient', width: 140 },
    {
      field: 'receipt',
      headerName: 'Refund Receipt',
      renderCell: (params) => (
        <Link to={`/refund-invoice-ip/${params.row.receipt}`} target="_blank">
          {params.row.receipt}
        </Link>
      ),
      width: 120
    },
    { field: 'refund_type', headerName: 'Refund Type', width: 140 },
    { field: 'refund_amount', headerName: 'Refund Amount', width: 120 },
    { field: 'receivedby', headerName: 'Received By', width: 100 },
    { field: 'reason', headerName: 'Reason', width: 100 },
    { field: 'addedby', headerName: 'Updated By', width: 100 },
  ];

const calculateTotals = (rows, keys) => {
  return rows.reduce((totals, row) => {
    keys.forEach((key) => {
      totals[key] += Number(row[key]) || 0;
    });
    return totals;
  }, Object.fromEntries(keys.map(key => [key, 0])));
};

const FooterInvoiced = ({ rows }) => {
  // Initialize totals for different payment modes
    const paymentKeys = ['advance', 'lab_tot', 'inv_tot', 'min_tot'];
  const paymentTotal = calculateTotals(rows, paymentKeys);
  let totalFeeCash = 0, totalFeeCard = 0, totalFeeUPI = 0, totalFeeAdvance = 0;
  let totalPaid = 0, totalBalance = 0, totalDiscount = 0;

  // Calculate totals based on payment mode and paid amounts
  rows.forEach(row => {

    if (row.mode === 'cash') {
      totalFeeCash += Number(row.paid); // Add paid amount for cash
    } else if (row.mode === 'UPI') {
      totalFeeUPI += Number(row.paid); // Add paid amount for UPI
    } else if (row.mode === 'advance') {
      totalFeeAdvance += Number(row.paid); // Add paid amount for advance
    } else if (row.mode === 'card') {
      totalFeeCard += Number(row.paid); // Add paid amount for creditpay
    }

    totalPaid += Number(row.paid); // Total paid amount across all modes
    totalBalance += Number(row.balance); // Total balance
    totalDiscount += Number(row.disc || 0); // Total discount, handle undefined
  });

  return (
    <div style={{ display: 'flex', flexDirection: 'column', padding: '2px' }}>
      {/* Payment Totals Section */}
      <div style={{ display: 'flex', justifyContent: 'space-evenly', marginBottom: '8px' }}>
     <div>Total: {(
          paymentTotal.advance + paymentTotal.lab_tot + paymentTotal.inv_tot + paymentTotal.min_tot
        ).toFixed(2)}</div>
        <div>Total Paid: {totalPaid.toFixed(2)}</div>
        <div>Balance: {totalBalance.toFixed(2)}</div>
        <div>Discount: {totalDiscount.toFixed(2)}</div>
      </div>

      {/* Payment Mode Totals Section */}
      <div style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: '8px' }}>
        <div>Cash Total: {totalFeeCash.toFixed(2)}</div>
        <div>Card Total: {totalFeeCard.toFixed(2)}</div>
        <div>UPI Total: {totalFeeUPI.toFixed(2)}</div>
        <div>Advance Total: {totalFeeAdvance.toFixed(2)}</div>
      </div>
    </div>
  );
};



  const today = new Date();


  const getTotal1 = (rows1, field) => {
    return rows1.reduce((total1, row1) => total1 + parseFloat(row1[field]), 0);
  };

   const Footer1 = ({ rows1 }) => {
  if (!rows1 || rows1.length === 0) {
    return (
      <div>No data available</div>
    );
  }

  const totalRefundAmount1 = getTotal1(rows1, 'refund_amount');
  return (
    <div style={{ display: 'flex', justifyContent: 'space-evenly', padding: '2px' }}>
      <div>Total</div>
      <div>{totalRefundAmount1}</div>
    </div>
  );
};


  return (
    <section className="container mt-4">
    <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
        aria-hidden="true" style={{color: 'red'}}></i> Payment Detail Report</h3>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label className="col-sm-3 col-lg-2 control-label">Select Date</label>
            <div className="col-sm-9 col-lg-10 controls">
            <DatePicker
                selected={startDate}
                onChange={handleStartDateChange}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                placeholderText={'Please select From date'}
                dateFormat="dd/MM/yyyy"
                showMonthDropdown
                showYearDropdown
            />
            </div>
            <div className="col-sm-9 col-lg-10 controls">
            <DatePicker
                selected={endDate}
                onChange={handleEndDateChange}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                maxDate={today}
                placeholderText={'Please select To date'}
                dateFormat="dd/MM/yyyy"
                showMonthDropdown
                showYearDropdown
            />
            </div>
            <div className="mb-4 mt-4">
              <label htmlFor="user" className="form-label">Search by Cashier</label>
              <select name="user" id="username" value={cashier.user} className="form-control"
                onChange={(event) => handleUser(event)}>
               <option value="">Select Cashier</option>
                {userData.map((User,index) => (
                <option key={index} value={User.username}>{User.username}</option>
                ))}
            </select>
            </div>
            </div>
        </div>
      </div>

    <div>
     <nav>
      <div className="nav nav-tabs" id="nav-tab" role="tablist">
      <button className="nav-link active border-success" id="nav-invoiced-tab" data-bs-toggle="tab"
            data-bs-target="#nav-invoiced" type="button" role="tab" aria-controls="nav-invoiced"
            aria-selected="true">Invoiced</button>
     <button className="nav-link  border-primary " id="nav-collected-tab" data-bs-toggle="tab"
        data-bs-target="#nav-collected" type="button" role="tab" aria-controls="nav-collected"
        aria-selected="false">Collected</button>
        <button className="nav-link  border-primary " id="nav-refund-tab" data-bs-toggle="tab"
            data-bs-target="#nav-refund" type="button" role="tab" aria-controls="nav-refund"
            aria-selected="false">Refund</button>
      </div>
    </nav>
  <div className="tab-content" id="nav-tabContent">
     <div className="tab-pane fade show active" id="nav-invoiced" role="tabpanel" aria-labelledby="nav-invoiced-tab">
         {!isLoading && combinedData.length > 0 && (
          <div>
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
              <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
              Invoiced Report
            </h3>
            <div style={{ height: "100%", width: '100%' }}>
              <DataGrid
                sx={{
                  boxShadow: 4,
                  border: 4,
                  borderColor: 'primary.light',
                  '& .MuiDataGrid-cell:hover': {
                    color: 'primary.main',
                  },
                }}
                rows={combinedData}
                columns={columnsInvoiced}
                pageSize={1000}
                slots={{
                  toolbar: GridToolbar,

                }}
                autoHeight
              />
            <table className="mt-4" style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tfoot>
              <FooterInvoiced rows={combinedData} />
            </tfoot>
          </table>
            </div>
          </div>
        )}
          </div>
      <div className="tab-pane" id="nav-collected" role="tabpanel" aria-labelledby="nav-collected-tab">
        {!isLoading && combinedData.length > 0 && (
          <div>
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
              <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
              Collection Report
            </h3>
            <div style={{ height: "100%", width: '100%' }}>
              <DataGrid
                sx={{
                  boxShadow: 4,
                  border: 4,
                  borderColor: 'primary.light',
                  '& .MuiDataGrid-cell:hover': {
                    color: 'primary.main',
                  },
                }}
                rows={combinedData.filter(payment => (payment.paid > 0 || payment.lab_paid > 0 || payment.inv_paid > 0 || payment.min_paid > 0))}
                columns={columnsInvoiced}
                pageSize={1000}
                slots={{
                  toolbar: GridToolbar,

                }}
                autoHeight
              />
              <table className="mt-4" style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <tfoot>
                      <FooterInvoiced rows={combinedData.filter(payment => (payment.paid > 0 || payment.lab_paid > 0 || payment.inv_paid > 0 || payment.min_paid > 0))} />
                    </tfoot>
                  </table>
            </div>
          </div>
        )}
          </div>
          <div className="tab-pane" id="nav-refund" role="tabpanel" aria-labelledby="nav-refund-tab">
              <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
                Refund Report
               </h3>
               {!isLoading && refundData.length > 0 ? (
                  <div style={{ height: "100%", width: "100%" }} className="mt-4">
                    <DataGrid
                      className="mt-4"
                      sx={{
                        boxShadow: 4,
                        border: 4,
                        borderColor: 'primary.light',
                        '& .MuiDataGrid-cell:hover': {
                          color: 'primary.main',
                        },
                      }}
                      rows1={refundData.map((row, index) => ({
                        ...row,
                        id: index + 1, // Add a unique id property to each row
                      }))}
                      columns={columns1}
                      pageSize={10}
                      slots={{
                        toolbar: GridToolbar,

                      }}
                      autoHeight
                    />
                    <table className="mt-4" style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <tfoot>
                      <Footer1 rows1={refundData} />
                    </tfoot>
                  </table>
                  </div>
              ) : (
                <></>
              )}
          </div>


        </div>
        </div>

    </section>
  );
}

export default PaymentDetailIp;
